import { AdvisorsPaths } from '@src/components/sco/Advisors/paths'
import { IconType } from 'react-icons'
import { LuGauge, LuIdCard, LuSettings, LuSquarePen, LuWallet } from 'react-icons/lu'

export type AdvisorProfileSectionKey = 'setup' | 'view' | 'edit' | 'settings' | 'payouts'

export type AdvisorProfileNavItem = {
  key: AdvisorProfileSectionKey
  title: string
  description: string
  href: string
  icon: IconType
}

export const advisorProfileNavItems = (paths: AdvisorsPaths): AdvisorProfileNavItem[] => [
  {
    key: 'setup',
    title: 'Setup',
    description: 'Go live, complete your profile, set rates, and connect payouts.',
    href: paths.ownProfile,
    icon: LuGauge,
  },
  {
    key: 'view',
    title: 'Profile',
    description: 'Preview how founders see your advisor card.',
    href: paths.profileView,
    icon: LuIdCard,
  },
  {
    key: 'edit',
    title: 'Edit',
    description: 'Jump into any application section and save.',
    href: paths.profileEdit,
    icon: LuSquarePen,
  },
  {
    key: 'settings',
    title: 'Settings',
    description: 'Booking hours, session rates, and match-email preferences.',
    href: paths.profileSettings,
    icon: LuSettings,
  },
  {
    key: 'payouts',
    title: 'Payouts',
    description: 'Stripe Connect, withdrawals, and payout history.',
    href: paths.profilePayouts,
    icon: LuWallet,
  },
]
